import {useContext, useState} from 'react';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import {IoMdApps} from 'react-icons/io';

import {LoadingPlaceholder} from 'src/components';
import {WorkspaceContext} from 'src/context';

import {Panel} from '../Panel';

import './styles.css';

const NO_SELECTED_WORKSPACE_DISPLAY_TEXT = '[No Workspace Selected]';

export const WorkspaceSelector = ({isExpanded = true}: {isExpanded?: boolean}) => {
  const [showWorkspaces, setShowWorkspaces] = useState(false);
  const {currentWorkspace, loading} = useContext(WorkspaceContext);


  const currentWorkspaceText = currentWorkspace ? currentWorkspace.displayName : NO_SELECTED_WORKSPACE_DISPLAY_TEXT;

  return (
    <Dropdown className='WorkspaceSelector' isOpen={showWorkspaces} toggle={() => setShowWorkspaces((v) => !v)}>
      <DropdownToggle className='WorkspaceToggle' color={'custom'}>
        <IoMdApps className='WorkspaceToggleIcon' fontSize='1em' title={currentWorkspaceText}/>
        {isExpanded &&
          <>
            {' '}
            <span className='WorkspaceSelected' title={currentWorkspaceText}>
              {loading ? (
              <LoadingPlaceholder plaintext />
              ) : (
                currentWorkspaceText
              )}
            </span>
          </>
        }
      </DropdownToggle>
      <DropdownMenu className='WorkspaceMenu'>
        <Panel onPerformAction={() => setShowWorkspaces(false)} />
      </DropdownMenu>
    </Dropdown>
  );
};
